import "./Header/header.scss";
import { type FC } from "react";
import { useMediaQuery } from "@onshopfront/components";
import AudioIcon from "./Header/AudioMenu/AudioIcon";
import { CurrentPageHelp } from "./Header/CurrentPageHelp";
import { CurrentUser } from "./Header/CurrentUser";
import CustomerDisplayIndicator from "./Header/CustomerDisplayIndicator";
import LocationSelector from "./Header/LocationHeader";
import { Menu } from "./Header/Menu";
import { NotificationIcon } from "./Header/Notifications/NotificationIcon";
import QuickMenuAndLogo from "./Header/QuickMenuAndLogo";
import { SiteStatus } from "./Header/SiteStatus";
import TeamMessage from "./Header/TeamMessage";

export const Header: FC = () => {
    const smallScreen = useMediaQuery("(max-width: 768px)");

    return (
        <header>
            <Menu />
            <QuickMenuAndLogo />
            <CustomerDisplayIndicator />
            <TeamMessage />
            <div id="header-right">
                <CurrentPageHelp />
                {!smallScreen && (
                    <>
                        <LocationSelector />
                        <AudioIcon />
                    </>
                )}
                <SiteStatus />
                <NotificationIcon />
                <CurrentUser />
            </div>
        </header>
    );
};
